import { render, staticRenderFns } from "./accept-invitation.vue?vue&type=template&id=f01a359e&"
import script from "./accept-invitation.vue?vue&type=script&lang=js&"
export * from "./accept-invitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports